import { useId } from "react";
import { cn } from "@/lib/cn";

export interface DeslizadorProps {
  etiqueta: string;
  valor: number;
  min: number;
  max: number;
  paso: number;
  onCambio: (valor: number) => void;
  /** Cómo se lee el valor al lado de la etiqueta y para el lector de pantalla ("17:30"). */
  formato?: (valor: number) => string;
  ayuda?: string;
  className?: string;
}

/** Un valor dentro de un rango, arrastrando (la hora del sol en el recorrido). Para montos o porcentajes exactos, los campos. */
export function Deslizador({ etiqueta, valor, min, max, paso, onCambio, formato = String, ayuda, className }: DeslizadorProps) {
  const id = useId();
  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      <div className="flex items-baseline justify-between gap-3">
        <label htmlFor={id} className="text-chico font-medium text-texto-suave">
          {etiqueta}
        </label>
        <span className="text-cuerpo font-medium tabular-nums" aria-hidden="true">
          {formato(valor)}
        </span>
      </div>
      <input
        id={id}
        type="range"
        className="h-8 w-full cursor-pointer accent-primario"
        min={min}
        max={max}
        step={paso}
        value={valor}
        aria-valuetext={formato(valor)}
        aria-describedby={ayuda ? `${id}-ayuda` : undefined}
        onChange={(e) => onCambio(Number(e.target.value))}
      />
      {ayuda && (
        <p id={`${id}-ayuda`} className="text-chico text-texto-suave">
          {ayuda}
        </p>
      )}
    </div>
  );
}
